import React, { useRef } from 'react';
import { CheckCircle } from 'lucide-react';
import servicecardimg1 from "../../../Assets/Service/icon1.png";
import servicecardimg2 from "../../../Assets/Service/icon2.png";
import servicecardimg3 from "../../../Assets/Service/icon3.png";
import ScrollArrowButtons from './../../common/ScrollArrowButtons';
export default function WorkProcessSection({ service }) {
    const processSteps = [
        {
            number: "01",
            title: "Extensive Talent Pool",
            description: "We have access to a vast network of talented professionals across various industries and domains.",
            icon: servicecardimg2
        },
        {
            number: "02",
            title: "Flexible Staffing Solutions",
            description: "We have access to a vast network of talented professionals across various industries and domains.",
            icon: servicecardimg1
        },
        {
            number: "03",
            title: "Cost-Effective",
            description: "We have access to a vast network of talented professionals across various industries and domains.",
            icon: servicecardimg3
        }
    ];

    const approaches = [
        {
            title: "Needs Assessment",
            description: "We start by understanding your specific requirements, including the skills, experience level, and duration needed for your project."
        },
        {
            title: "Candidate Selection",
            description: "Our team sources and screens candidates, shortlisting only those who match your criteria. Each candidate is vetted for technical skills, cultural fit, and professionalism as presented for your consideration."
        },
        {
            title: "Seamless Onboarding",
            description: "Our staff augmentation strategic involves boarding in 10L, administrative and documentation and recruiting has improved and streamlined to integrate smoothly into your existing workflows."
        },
        {
            title: "Ongoing Conversations",
            description: "We maintain regular contact with you and the augmented staff to ensure ongoing success. We are available to address concerns and make adjustments as project is successful engagement."
        }
    ];

    const scrollRef = useRef(null)

    const scrollLeft = () => {
        scrollRef.current.scrollBy({
            left: -320,
            behavior: "smooth"
        })
    }

    const scrollRight = () => {
        scrollRef.current.scrollBy({
            left: 320,
            behavior: "smooth"
        })
    }

    return (
        <div className="bg-white">
            {/* Work Process Section with Split Background */}
            {
                service?.section3 && <div className="relative">
                    {/* Split Background */}
                    <div className="absolute inset-0 flex">
                        <div className="w-full lg:w-1/2 bg-gradient-to-r from-blue-500 to-cyan-400"></div>
                        <div className="hidden lg:block w-1/2 bg-blue-950"></div>
                    </div>

                    {/* Content */}
                    <div className="relative max-w-[1400px] mx-auto px-6 xl:py-20 md:py-14 py-7">
                        {/* Header Section */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* Left Side - Title */}
                            <div data-aos="fade-up-right" data-aos-duration="1000">
                                <p className="text-white text-sm font-medium uppercase tracking-wider mb-3">
                                    SOME EASY STEPS TO PROCESS!
                                </p>
                                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
                                    {service?.section3?.title}
                                </h2>
                            </div>

                            {/* Right Side - Description */}
                            <div data-aos="fade-up-left" data-aos-duration="1000" className="flex items-center">
                                <div className="lg:pl-8">
                                    <p className="text-white text-justify md:text-left text-base leading-relaxed mb-4">{service?.section3?.content}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Process Cards */}
                        <div data-aos="fade-up-left" data-aos-duration="1000" className="flex justify-end gap-4 p-4">
                            <ScrollArrowButtons scrollLeft={scrollLeft} scrollRight={scrollRight} />
                        </div>
                        <div data-aos="fade-up" data-aos-duration="1000" ref={scrollRef} className="flex overflow-x-scroll overflow-y-hidden no-scrollbar snap-x snap-mandatory gap-6">
                            {service?.section3?.steps?.map((step, index) => {
                                const Icon = step.icon;
                                return (
                                    <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100}
                                        key={index}
                                        className="bg-white snap-center shrink-0 w-full lg:w-[29rem] xl:w-[27rem] rounded-3xl md:p-8 p-5 shadow-lg hover:shadow-xl transition-shadow duration-300"
                                    >
                                        {/* Number Badge */}
                                        <div className="bg-blue-950 text-white w-16 h-16 rounded-2xl flex items-center justify-center text-2xl font-bold mb-6">
                                            {step.step}
                                        </div>

                                        {/* Title */}
                                        <h3 className="text-xl font-bold text-blue-950 mb-4">
                                            {step.title}
                                        </h3>

                                        {/* Description */}
                                        <p className="text-gray-600 text-justify md:text-left text-sm leading-relaxed mb-8">
                                            {step.content}
                                        </p>

                                        {/* Icon */}
                                        <div className="flex justify-center mt-8">
                                            {/* <Icon className="w-16 h-16 text-blue-600 stroke-[1.5]" /> */}
                                            {<img src={step.icon} alt={step.title} className="w-16 h-16" />}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            }

            {/* Our Approach Section */}
            <div className="md:py-14 py-7">
                <div className="max-w-[1400px] mx-auto px-6">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
                        {/* Left Column - Approach Details */}
                        <div data-aos="fade-up" data-aos-duration="1000">
                            <h2 className="text-3xl sm:text-4xl font-semibold font-SpaceGrotesk text-primaryColor mb-6">
                                {service?.section4?.title}
                            </h2>

                            <p className="text-gray-600 text-sm leading-relaxed mb-8">
                                {service?.section4?.content}
                            </p>

                            {/* Approach Steps */}
                            <div className="space-y-6">
                                {service?.section4?.points?.map((approach, index) => (
                                    <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={index} className="flex gap-4">
                                        {/* Check Icon */}
                                        <div className="flex-shrink-0">
                                            <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                                                <CheckCircle className="w-5 h-5 text-white" />
                                            </div>
                                        </div>

                                        {/* Content */}
                                        <div>
                                            <h3 className="text-lg font-bold text-gray-900 mb-2">
                                                {approach.label}
                                            </h3>
                                            <p className="text-gray-600 text-sm leading-relaxed">
                                                {approach.content}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Right Column - Stats & Image */}
                        <div className="space-y-6">
                            {/* Stats Card */}
                            <div data-aos="fade-up-left" data-aos-duration="1000" className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-8 text-center">
                                <div className="text-5xl font-bold text-gray-900 mb-2">
                                    3,000+
                                </div>
                                <p className="text-gray-700 font-medium">
                                    Happy Clients World wide
                                </p>
                            </div>

                            {/* Image Card */}
                            <div data-aos="fade-up-left" data-aos-duration="1000" className="relative rounded-2xl overflow-hidden shadow-xl">
                                <img
                                    src={service?.section4?.images}
                                    alt="Team collaboration"
                                    className="w-full h-80 object-cover"
                                />
                                {/* Overlay effect */}
                                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent"></div>

                                {/* Decorative elements */}
                                <div className="absolute top-4 right-4 flex gap-2">
                                    <div className="w-3 h-3 bg-blue-400 rounded-full animate-pulse"></div>
                                    <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse delay-100"></div>
                                    <div className="w-3 h-3 bg-yellow-400 rounded-full animate-pulse delay-200"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}